export default __webpack_public_path__ + "static/media/zalo-oa.71fbb128.png";